<template>
  <div>
      <form @submit.prevent="submitForm()">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Form Engine</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'instanceFormEngineCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>

                <h4 class="page-title">
                    <router-link :to="{ name: 'instanceFormEngine' }" :disabled="loading">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Form Engine
                </h4>
                </div>
            </div>
        </div>

        <div class="card card-loader d-flex" v-if="loadingInitial">
            <div class="justify-content-center">
                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2">Loading</p>
            </div>
        </div>

        <div v-else>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-0" :class="{ 'is-invalid': $v.engineForm.name.$error }">
                                <label for="example-text-input" class="col-form-label text-left d-block">Nama Form</label>
                                <input class="form-control" type="text" value="" placeholder="eg. Formulir Pembayaran Sampah" id="example-text-input"
                                v-model.trim="$v.engineForm.name.$model" :disabled="loading">
                                <div class="error" v-if="!$v.engineForm.name.required">Nama form wajib diisi</div>
                                <div class="error" v-if="!$v.engineForm.name.minLength">Nama form minimal 3 karakter</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-0">
                                <label class="col-form-label text-left d-block">Tipe Form</label>
                                <select class="form-control" id="exampleFormControlSelect1" v-model="engineForm.form_type" @change="changeFormType" :disabled="loading">
                                    <option value="SERVICE">SERVICE</option>
                                    <option value="CUSTOMER">CUSTOMER</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex">
                <button type="button"
                class="btn btn-primary waves-effect waves-light" style="margin-bottom: 20px; margin-left:auto" @click="addField()" :disabled="loading">
                    <i class="fas fa-plus mr-2"></i>
                    <span>Tambah</span>
                </button>
            </div>

            <draggable
                :list="engineForm.custom_fields"
                :disabled="!enabled"
                class="list-group"
                ghost-class="ghost"
                v-bind="dragOptions"
                @start="dragging = true"
                @end="dragging = false"
            >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div class="card mb-0 dragable-item" v-for="(item, index) in $v.engineForm.custom_fields.$each.$iter" :key="item.name+index" style="border-bottom: 1px solid #ddd; border-radius: 0px">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-1 text-center">
                                    <button type="button"  
                                    :disabled="engineForm.custom_fields.length <= 1"
                                    class="btn waves-effect waves-light mb-2"
                                    :class="classButton"
                                    @click="removeField(index, item.$model.id)">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                    
                                </div>
                                <div class="col-11">
                                    <div class="row">
                                        <div class="col-5">
                                            <div class="form-group mb-0" :class="{ 'is-invalid': item.label.$error }">
                                                <label class="form-label text-left">Label</label>
                                                <input class="form-control" type="text" v-model.trim="item.label.$model" placeholder="eg. Tipe Kantin" :disabled="loading">
                                                <div class="error" v-if="!item.label.required">Label wajib diisi</div>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="form-group mb-0" :class="{ 'is-invalid': item.field_type.$error }">
                                                <label class="form-label text-left">Field Type</label>
                                                <select class="form-control" id="exampleFormControlSelect1" v-model="engineForm.custom_fields[index].field_type" :disabled="loading">
                                                    <option value="TEXT">Text</option>
                                                    <option value="NUMBER">Number</option>
                                                    <option value="DATE">Date</option>
                                                    <option value="SELECT">Select</option>
                                                    <div class="error" v-if="!item.label.required">Field Type wajib diisi</div>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-3">
                                            <label class="col-form-label text-left d-block">Tampilkan Pada Report</label>
                                            <div class="form-check form-group">
                                                <div class="custom-control custom-switch switch-primary" style="padding-left: 15px">
                                                    <input type="checkbox" class="custom-control-input" :id="'report-file' + index" v-model="engineForm.custom_fields[index].is_show_on_pdf">
                                                    <label class="custom-control-label" :for="'report-file' + index" style="cursor: pointer"></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="engineForm.custom_fields[index].field_type == 'SELECT'">
                                            <div class="form-group mt-3 mb-0">
                                                <label class="form-label text-left">Pilih Master Data</label>
                                                <select class="form-control" id="exampleFormControlSelect1" v-model="engineForm.custom_fields[index].master_data_id"
                                                :disabled="loading" required>
                                                    <option value="" selected disabled>-- PILIH MASTER DATA --</option>
                                                    <option :value="item.id" v-for="item in masterData" :key="item.id">{{item.name}}</option>
                                                </select>
                                            </div>
                                            <router-link v-if="masterData.length <= 0"
                                                class="btn btn-primary waves-effect waves-light mt-3 w-100" style="margin-bottom: 20px; margin-left:auto" 
                                                to="/instance/master-data" :disabled="loading">
                                                <span>Anda belum memiliki master data, buat sekarang</span>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>

            <button class="btn btn-success waves-effect waves-light mb-5" style="margin-top: 20px;" :disabled="loading">
                Simpan Form Engine
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </div>

      </form>

  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import draggable from 'vuedraggable'
    import { required, minLength } from 'vuelidate/lib/validators'

    export default {
        data() {
            return {
                loadingInitial: false,
                loading: false,

                engineForm: {
                    name: '',
                    form_type: 'SERVICE',
                    custom_fields: [
                        { 
                            name: '',
                            label: '',
                            field_type: 'TEXT',
                            master_data_id: '',
                            is_show_on_pdf: 0,
                        }
                    ]
                },
                masterData: [],
                masterDataTemporary: [],
                deleted_custom_fields_ids: [],

                enabled: true,
                dragging: false,
                drag: false
            };
        },
        validations: {
            engineForm: {
                name: {
                    required,
                    minLength: minLength(3)
                },
                custom_fields: {
                    $each: {
                        label: {
                            required
                        },
                        field_type: {
                            required
                        }
                    }
                },
            }
        },
        components: {
            draggable
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            classButton() {
                return this.engineForm.custom_fields.length > 1 ? 'btn-danger' : 'btn-info'
            }
        },
        methods: {
            changeFormType() {
                this.engineForm.custom_fields.forEach(element => {
                    element.master_data_id = ''
                })

                if(this.engineForm.form_type == 'SERVICE'){
                    this.masterData = this.masterDataTemporary.filter(item => {
                        return item.type == 'SERVICE' || item.type == 'GENERAL'
                    })
                }else{
                    this.masterData = this.masterDataTemporary.filter(item => {
                        return item.type == 'CUSTOMER' || item.type == 'GENERAL'
                    })
                }
            },
            addField() {
                this.engineForm.custom_fields.push({
                    id: null,
                    name: '',
                    label: '',
                    field_type: 'TEXT',
                    master_data_id: '',
                    is_show_on_pdf: 0,
                })
            },
            removeField(index, id) {
                Swal.fire({
                title: 'Apakah anda yakin untuk menghapus?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya, Hapus!'
                }).then((result) => {
                    if(id){
                        this.deleted_custom_fields_ids.push(id)
                    }
                    if (result.value) {
                        this.engineForm.custom_fields.splice(index, 1)
                    }
                })
            },

            submitForm() {
                if (this.$v.engineForm.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess, storedData
                if(this.$route.name == 'instanceFormEngineCreate') {
                    url = `form-template/store`
                    method = 'POST',
                    alertSuccess = 'Berhasil membuat template form baru!'
                    
                    storedData = this.engineForm.custom_fields.map(item => {
                        return {
                            name: this.slugify(item.label),
                            label: item.label,
                            field_type: item.field_type,
                            is_show_on_pdf: item.is_show_on_pdf ? 1 : 0,
                            master_data_id: item.master_data_id
                        }
                    })
                    storedData = { name: this.engineForm.name, form_type: this.engineForm.form_type, custom_fields: storedData }
                }else{
                    url = `form-template/update/${this.$route.params.id}`
                    method = 'PUT',
                    alertSuccess = 'Berhasil mengupdate template form!'
                    
                    const dataCustomField = this.engineForm.custom_fields.map(item => {
                        return {
                            id: item.id,
                            name: this.slugify(item.label),
                            label: item.label,
                            field_type: item.field_type,
                            is_show_on_pdf: item.is_show_on_pdf ? 1 : 0,
                            master_data_id: item.master_data_id
                        }
                    })
                    storedData = { 
                        name: this.engineForm.name, 
                        form_type: this.engineForm.form_type, 
                        custom_fields: dataCustomField,
                        deleted_custom_fields_ids: this.deleted_custom_fields_ids
                    }
                }

                if(!this.engineForm.name){
                    this.loading = false
                    return this.sAlert('error', "Pastikan semua form terisi dengan benar!")
                }

                // VALIDATE DATA
                const validateNull = this.engineForm.custom_fields.filter(item => {
                    return !item.label
                })

                if(validateNull.length > 0){
                    this.sAlert('error', "Pastikan semua form terisi dengan benar!")
                    this.loading = false;
                }else {

                    // POST DATA
                    this.$http({
                        method,
                        url: `${this.API_URL}${url}`,
                        data: storedData,
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    })
                    .then(response => {
                        const result = response.data;
                        
                        if(result.success) {
                            this.sAlert('success', alertSuccess)
                            this.$router.push({ name: 'instanceFormEngine' });
                        }else {
                            this.sAlert('error', result.message)
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                        this.sAlert('error', "Error, Terjadi Kesalahan!")
                    });
                }
            }
        },
        async mounted() {
            this.loadingInitial = true

            await this.$http.get(`${this.API_URL}master-data`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                this.loadingInitial = false

                const result = response.data;

                if(result.success) {
                    this.masterDataTemporary = result.data
                    this.masterData = this.masterDataTemporary.filter(item => {
                        return item.type == 'SERVICE' || item.type == 'GENERAL'
                    })
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loadingInitial = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });

            if(this.$route.name == 'instanceFormEngineEdit'){
                this.loadingInitial = true

                this.$http.get(`${this.API_URL}form-template/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;

                    if(result.success) {
                        this.engineForm.name = result.data.name
                        this.engineForm.form_type = result.data.form_type
                        this.masterData = this.masterDataTemporary.filter(item => {
                            return item.type == result.data.form_type || item.type == 'GENERAL'
                        })
                        this.engineForm.custom_fields = result.data.custom_fields
                    }else {
                        this.sAlert('error', result.message)
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        }
    }
</script>